const getValueOfObject = (
  obj: any,
  pathWithDefault: string,
  fallback: any = ''
) => {
  const [path, explicitDefault] = pathWithDefault.split(':');
  const keys = path.split('.');
  const defaultValue =
    explicitDefault !== undefined ? JSON.parse(explicitDefault) : fallback;

  return keys.reduce((acc, key, index) => {
    if ((acc === null || acc === undefined) && index < keys.length - 1) {
      return {};
    }
    return acc && acc[key] !== undefined ? acc[key] : defaultValue;
  }, obj);
};

export const formatProfile = (data: any) => {
  try {
    const studentData = data.getEmailAndPhone.data;
    const objProfile = {
      email: 'email.email',
      emailPermission: 'email.hasEditingPermissionEmail:true',
      phone: 'phone.phoneNumber',
      phonePermission: 'phone.hasEditingPermissionPhone:true'
    };
    const result = Object.entries(objProfile).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: getValueOfObject(studentData, value)
      }),
      {}
    );

    return { ...result, isLoading: data.getEmailAndPhone.isLoading };
  } catch (error) {
    return null;
  }
};

export function CapitalizeEachWord(texto: string) {
  return texto
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export type TProfile = {
  campus?: string;
  career?: string;
  dni?: string;
  email: string;
  emailPermission: boolean;
  phone: string;
  phonePermission: boolean;
  isLoading?: boolean;
} | null;

export type TProfileData = {
  studentCode: string;
  nationalId: string;
  birthdate: string;
  cellPhone: string;
  emailAddr: string;
  maritalStatus: string;
  maritalStatusDescr: string;
  address1: string;
  country: string;
  countryDescr: string;
  state: string;
  stateDescr: string;
  county: string;
  countyDescr: string;
  city: string;
  cityDescr: string;
  utpFlag: string;
  utpTipoMovilidad: string;
  tipoMovilidadDescr: string;
  utpNroPlaca: string;
  contactName: string;
  relationship: string;
  relationshipDescr: string;
  emergencyPhone: string;
  utpTipoDiscap: string;
  utpDetaDiscap: string;
  utpTipoCondicion: string;
  utpDetaCondicion: string;
  utpNroConadis: string;
  utpNroResolucion: string;
  utpGenero: string;
  sex: string;
  utpEstTrans: string;
  utpDeclaracion: string;
  utpComunidad: string;
  utpPuebloOrig: string;
  utpNomPueblo: string;
  utpResolucPueblo: string;
  utpLenguaMat: string;
  utpCodCostumbres: string;
} | null;

export type TFullName = {
  firstName: string;
  lastName: string;
};
